import React, { useState, useEffect } from "react";

function ProductMultiSelector({
  selectedProducts,
  availableProducts,
  onSelect,
  onRemove,
  onRemoveAll,
  readOnly = "false",
  openAtStart = false,
  onConfirm,
}) {
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState(selectedProducts || []);
  const [pendingChanges, setPendingChanges] = useState({
    toAdd: [],
    toRemove: [],
  });
  const [filter, setFilter] = useState("");
  const [showSelector, setShowSelector] = useState(openAtStart);

  const selectAll = () => {
    setFilter("");
    const productsToAdd = products.filter(
      (product) => !selected.some((prod) => prod === product)
    );
    setPendingChanges({ toAdd: productsToAdd, toRemove: [] });
    setSelected(products);
  };

  const clearAll = () => {
    setFilter("");
    setPendingChanges({ toAdd: [], toRemove: [...selected] });
    setSelected([]);
  };

  const confirmChanges = () => {
    if (pendingChanges.toAdd.length > 0 || pendingChanges.toRemove.length > 0) {
      if (
        pendingChanges.toRemove.length > 0 &&
        pendingChanges.toRemove.length === selectedProducts.length &&
        pendingChanges.toAdd.length === 0
      ) {
        onRemoveAll();
      } else {
        onConfirm && onConfirm(pendingChanges);
      }
    }

    setPendingChanges({ toAdd: [], toRemove: [] });
    setShowSelector(false);
  };

  useEffect(() => {
    setSelected(selectedProducts || []);
    if (availableProducts) {
      setProducts(
        [
          ...new Set([
            ...(availableProducts || []),
            ...(selectedProducts || []),
          ]),
        ].sort((a, b) => a.localeCompare(b))
      );
    }
  }, []);

  useEffect(() => {
    setSelected(selectedProducts || []);
    if (availableProducts) {
      setProducts(
        [
          ...new Set([
            ...(availableProducts || []),
            ...(selectedProducts || []),
          ]),
        ].sort((a, b) => a.localeCompare(b))
      );
    }
  }, [availableProducts, selectedProducts]);

  if ([true, "true"].includes(readOnly)) return null;

  if (!showSelector) {
    return (
      <div className="d-flex flex-row">
        <button
          type="button"
          className="btn btn-outline-primary w9 h2"
          onClick={() => setShowSelector(true)}
        >
          Wybierz produkty
        </button>
      </div>
    );
  }

  return (
    <div className="w-100">
      <div className="d-flex flex-row">
        <input
          type="text"
          className="form-control h2 w25 rounded-end-0"
          placeholder="Filtruj produkty"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-outline-secondary border border-start-0 rounded-start-0 h2 tooltip text-dark"
          onClick={() => setFilter("")}
        >
          X<span className="tooltiptext">Wyczyść filtr</span>
        </button>
        <button
          type="button"
          className="btn btn-outline-primary w9 h2 ms-auto tooltip"
          onClick={() => selectAll()}
        >
          Dodaj wszystkie
          <span className="tooltiptext">
            Dodaje wszystkie produkty do procesu produkcji
          </span>
        </button>
        <button
          type="button"
          className="btn btn-outline-primary w9 h2 ms-1 tooltip"
          onClick={() => clearAll()}
        >
          Usuń wszystkie
          <span className="tooltiptext">
            Usuwa wszystkie produkty z procesu produkcji
          </span>
        </button>
      </div>
      {products.length > 0 &&
        [false, "false"].includes(readOnly) &&
        products
          .filter((product) =>
            product.toLowerCase().includes(filter.toLowerCase())
          )
          .map((product, indx) => (
            <div key={"product_" + indx} className="d-flex flex-row mt-1">
              <input
                type="checkbox"
                className="form-check-input"
                id={"product_" + indx}
                value={product}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelected((prevProducts) => [...prevProducts, product]);
                    setPendingChanges((prev) => ({
                      toAdd: [
                        ...prev.toAdd.filter((p) => p !== product),
                        product,
                      ],
                      toRemove: prev.toRemove.filter((p) => p !== product),
                    }));
                  } else {
                    setSelected((prevProducts) =>
                      prevProducts.filter((prod) => prod !== product)
                    );
                    setPendingChanges((prev) => ({
                      toAdd: prev.toAdd.filter((p) => p !== product),
                      toRemove: selectedProducts.includes(product)
                        ? [
                            ...prev.toRemove.filter((p) => p !== product),
                            product,
                          ]
                        : prev.toRemove,
                    }));
                  }
                }}
                checked={selected.some((prod) => prod === product)}
              />
              <label className="form-check-label" htmlFor={"product_" + indx}>
                {product}
              </label>
            </div>
          ))}
      <button
        type="button"
        className="btn btn-outline-primary rounded-2 w9 h2 mt-1"
        onClick={confirmChanges}
      >
        Zatwierdź
      </button>
    </div>
  );
}

export default ProductMultiSelector;
